import InputLabelWithIcon from './InputLabelWithIcon';

export default InputLabelWithIcon;
